import React, { Component } from "react";
import axios from "axios";

import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Center,
  Box,
  Text,
  IconButton,
  Flex,
  Spacer,
  Image,
  Wrap,
  WrapItem,
  Stack,
  Icon,
  HStack,
  Tr,
  Td,
  Table,
  Thead,
  Th,
  Tbody,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { v4 as uuidv4 } from "uuid";
import parse from "html-react-parser";

//import * as ohs from "../../imgs/pd/ohs";

function importAll(r) {
  let images = {};
  r.keys().forEach((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}

const ohs = importAll(
  require.context("../../imgs/pd/ohs", false, /\.(png|jpe?g|svg|pdf)$/)
);

const pdContent = importAll(
  require.context("../../imgs/pd/list", false, /\.(png|jpe?g|svg|txt|pdf)$/)
);

const healthnsafety = importAll(
  require.context(
    "../../imgs/pd/healthnsafety",
    false,
    /\.(png|jpe?g|svg|txt|pdf)$/
  )
);

const policiesContent = importAll(
  require.context("../../imgs/pd/policies", false, /\.(png|jpe?g|svg|txt|pdf)$/)
);

const rto2015 = importAll(
  require.context("../../imgs/pd/rto2015", false, /\.(png|jpe?g|svg|txt|pdf)$/)
);

//for html clean up
/*module.exports = function (props) {
  return ( )};*/

var embCss = `<style>
body {background-color: powderblue;}
h1   {font-size:5vw;}
h2   {font-size:3vw;}
h1,h2,h3{font-weight: bold;}
li    {font-weight: bold;}
br,hr {padding: 50px;}
a {padding: 50px; font-size:3vw; color: blue;}
</style>`;

var COLORS = [];
while (COLORS.length < 100) {
  COLORS.push(`rgb(${rand(0, 255)}, ${rand(0, 255)}, ${rand(0, 255)})`);
}

// random number generator
function rand(frm, to) {
  return ~~(Math.random() * (to - frm)) + frm;
}

class PdView extends Component {
  state = {
    lstOhs: [],
    lstPd: [],
    lstHealth: [],
    lstRto2015: [],
    isOpen: false,
  };

  componentDidMount() {
    this.addMoreListeners();
  }

  async addMoreListeners() {
    this.props.chatSocket.on("getPDLocations", (data) => {
      var j = JSON.parse(data);

      var tmpOhs = [];
      var tmpPd = [];
      var tmpHealth = [];
      var tmpPolicies = [];
      var tmpRto2015 = [];
      for (var o in j["pd"]) {
        if (j["pd"][o]["type"] == "ohs") {
          tmpOhs.push(j["pd"][o]);
        } else if (j["pd"][o]["type"] == "pd") {
          tmpPd.push(j["pd"][o]);
        } else if (j["pd"][o]["type"] == "health and safety") {
          tmpHealth.push(j["pd"][o]);
        } else if (j["pd"][o]["type"] == "policies") {
          tmpPolicies.push(j["pd"][o]);
        } else if (j["pd"][o]["type"] == "rto 2015") {
          tmpRto2015.push(j["pd"][o]);
        }
      }
      this.setState({
        lstOhs: tmpOhs,
        lstPd: tmpPd,
        lstHealth: tmpHealth,
        lstPolicies: tmpPolicies,
        lstRto2015: tmpRto2015,
      });
    });

    this.props.chatSocket.emit("getPDLocations", "hello");
  }

  async onClickOpenOHS(link, id, title, offsite) {
    if (link) {
      if (link.endsWith(".pdf")) {
        window.open(link, "_blank").focus();
      } else if (link.endsWith(".txt")) {
        var txt = await axios.get(link);
        //console.log(txt["data"]);

        this.setState({
          isOpen: true,
          html: txt["data"],
          title: title,
          viewHtmlLink: link,
        });
      } else {
        alert("unknown item");
      }
    } else {
      window.open(offsite, "_blank").focus();
    }

    var j = { user: this.props.user, id: id };
    var jData = JSON.stringify(j);

    this.props.chatSocket.emit("saveUserPD", jData);
  }

  generateLinks(lstItems, lstSync) {
    //const { lstOhs } = this.state;
    var lst = [];
    var addedCount = 1;

    var foundCatergories = false;
    var lstCatergories = new Map();

    for (var i = 0; i <= 100; i++) {
      var selectedOhs = null;
      for (var o in lstItems) {
        if (lstItems[o]["pd_id"] == i) {
          selectedOhs = lstItems[o];

          if (lstItems[o]["pd_text"]) {
            foundCatergories = true;
            lstCatergories.set(lstItems[o]["pd_text"]);
          }

          break;
        }
      }

      if (selectedOhs != null) {
        var boxBG = "";
        if ((addedCount + 1) % 2 == 0) {
          boxBG = "green.800";
        } else {
          boxBG = "green.600";
        }
        addedCount += 1;

        var pdf = lstSync[i + ".pdf"];

        if (!pdf) {
          pdf = lstSync[i + ".txt"];
        }

        var jpg = lstSync[i + ".jpg"];
        lst.push([
          pdf,
          jpg,
          selectedOhs["pd_title"],
          selectedOhs["pd_duration"],
          i,
          selectedOhs["pd_text"],
          selectedOhs["pd_link"],
        ]);
      }
    }

    if (!foundCatergories) {
      var lstExport = lst.map((userData) => (
        <div key={uuidv4()} className="uiq_tr">
          <Box
            w="200px"
            m="10px"
            onClick={() =>
              this.onClickOpenOHS(
                userData[0],
                userData[4],
                userData[2],
                userData[6]
              )
            }
          >
            <Stack>
              <Center>
                <Image src={userData[1]} alt={userData[2]} boxSize="150px" />
              </Center>
              <Box w="100%">
                <Text>{userData[3]}</Text>
              </Box>
              <Box w="100%">
                <Text>{userData[2]}</Text>
              </Box>
            </Stack>
          </Box>
        </div>
      ));

      return lstExport;
    } else {
      var lstTmp = [];
      var boxBGCount = 0;
      for (const [key, value] of lstCatergories.entries()) {
        lstTmp.push(
          <div key={uuidv4()} className="uiq_tr">
            <Box w="90vw" bg={COLORS[boxBGCount]}>
              <Center>
                <Text p="20px" bg="green.800">
                  {key}
                </Text>
              </Center>
            </Box>
          </div>
        );

        var tmpLstItems = [];

        for (var l in lst) {
          if (lst[l][5] == key) {
            tmpLstItems.push(lst[l]);
          }
        }

        var lstExport = tmpLstItems.map((userData) => (
          <div key={uuidv4()} className="uiq_tr">
            <Box
              w="200px"
              m="10px"
              onClick={() =>
                this.onClickOpenOHS(
                  userData[0],
                  userData[4],
                  userData[2],
                  userData[6]
                )
              }
            >
              <Stack>
                <Center>
                  <Image src={userData[1]} alt={userData[2]} boxSize="150px" />
                </Center>
                <Box w="100%">
                  <Text>{userData[3]}</Text>
                </Box>
                <Box w="100%">
                  <Text>{userData[2]}</Text>
                </Box>
              </Stack>
            </Box>
          </div>
        ));

        lstTmp.push(lstExport);

        boxBGCount += 1;
      }

      return lstTmp;
    }
  }

  htmlDecode(input) {
    var e = document.createElement("div");
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  }

  render() {
    const {
      events,
      dataLoaded,
      lstOhs,
      lstPd,
      lstHealth,
      lstPolicies,
      lstRto2015,
      isOpen,
      html,
      viewHtmlLink,
    } = this.state;
    //PD List 2022
    //<img src={ohs["1.pdf"]} />;
    //console.log(ohs["1.pdf"]);

    /*<Tab>PD List</Tab>
            <Tab>OHS Act & Regulations</Tab>
            <Tab>Standards for RTOs 2015</Tab>
            <Tab>TDT Policies and Procedures</Tab>
            <Tab>Health and Safety</Tab>*/

    //doesnt import html properly :(
    /*<div
                className="Container"
                dangerouslySetInnerHTML={{ __html: html }}
              ></div>*/
    return (
      <Box w="100%">
        <Drawer placement="top" isOpen={isOpen} size="full">
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader borderBottomWidth="1px">
              <Button onClick={() => this.setState({ isOpen: false })}>
                Back
              </Button>
            </DrawerHeader>
            <DrawerBody>
              <div
                className="Container"
                dangerouslySetInnerHTML={{ __html: embCss + html }}
              ></div>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
        <Tabs variant="soft-rounded" colorScheme="green">
          <TabList>
            <Tab>PD</Tab>
            <Tab>OHS Act & Regulations</Tab>
            <Tab>Health & Safety</Tab>
            <Tab>TDT Policies and Procedures</Tab>
            <Tab>RTOs 2015</Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <div className="uiq_tbl_same_bg">
                {this.generateLinks(lstPd, pdContent)}
              </div>
            </TabPanel>
            <TabPanel>
              <div className="uiq_tbl_same_bg">
                {this.generateLinks(lstOhs, ohs)}
              </div>
            </TabPanel>
            <TabPanel>
              <div className="uiq_tbl_same_bg">
                {this.generateLinks(lstHealth, healthnsafety)}
              </div>
            </TabPanel>
            <TabPanel>
              <div className="uiq_tbl_same_bg">
                {this.generateLinks(lstPolicies, policiesContent)}
              </div>
            </TabPanel>
            <TabPanel>
              <div className="uiq_tbl_same_bg">
                {this.generateLinks(lstRto2015, rto2015)}
              </div>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    );
  }
}

export default PdView;
